<script>
  import {Icon} from '@components';
  export let onClose;
</script>

<button type="button" on:click={onClose} class="absolute right-0 z-50 cursor-pointer p-2.5"
  ><Icon name="Cross" className="w-3.5 h-3.5 text-gray-300 hover:text-gray-600 transition-colors" /></button
>
